import { useQuery } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

export type TrackingPopData = {
    idx: string;
    c_code: string;
    c_branch: string;
    s_kind: string;
    s_pay_kind: string;
    s_pay_company_code: string;
    s_pay_company: string;
    s_pay_tel: string;
    s_pay_name: string;
    s_pay_post: string;
    s_pay_address: string;
    s_pay_address_detail: string;
    s_cnt: number;
    s_weight: number;
    a_company: string;
    a_tel: string;
    a_part: string;
    a_part_sn: string;
    a_name: string;
    a_request: string;
    a_request2: string;
    f_c_code: string;
    f_company: string;
    f_tel: string;
    f_name: string;
    f_mobile: string;
    f_post: string;
    f_address: string;
    f_address_detail: string;
    f_dam_code: string;
    t_c_code: string;
    t_company: string;
    t_tel: string;
    t_name: string;
    t_mobile: string;
    t_post: string;
    t_address: string;
    t_address_detail: string;
    accept_date: string;
    accept_num: string;
    accept_seq: number;
    roll: number;
    box: number;
    sample: number;
};

type GetTrackingPopResponse = {
    statusCode: number;
    message: string;
    data: TrackingPopData;
};

export const useGetTrackingPop = (idx: string) => {
    return useQuery<TrackingPopData>({
        queryKey: ["useGetTrackingPop", idx],
        queryFn: async () => {
            const { data } = await axiosInstance.get<GetTrackingPopResponse>(`${enum_api_uri.tracking_pop}?idx=${idx}`);
            return data.data;
        },
        enabled: !!idx,
    });
};
